module.exports = __webpack_public_path__ + "static/harbor-dept-openings-b140d5c8d5726e90fcf0ffb6b7a9044b.jpg";